import Navbar from './Navbar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      {/* lg:ml-60 offsets the fixed 240px sidebar; pt-14 offsets the mobile top bar */}
      <main className="lg:ml-60 pt-14 lg:pt-0 min-h-screen">
        <div className="p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
